(function () {
  class SymBackgroundAnimDisplay extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name;
      this._anims = [];
      this._mysteryBackingAnims = [];
      this._currentCallback = undefined;
    }

    update(delta, time) {}

    onGameConfigEvent(task) {
      for (let reel = 0; reel < 5; reel++) {
        let rowAnim = [];
        for (let row = 0; row < 3; row++) {
          let anim = resourceManager.get(this._jsonPath + ':symBackgroundAnimReel' + reel + ':symBackAnim_' + row);
          anim.gotoAndStop(0);
          anim.visible = false;
          let animData = {
            anim: anim,
            task: undefined,
            active: false,
          };

          rowAnim.push(animData);
        }
        this._anims.push(rowAnim);
      }

      // Create mystery backing animations for each reel/row position
      for (let reel = 0; reel < 5; reel++) {
        let rowAnims = [];
        for (let row = 0; row < 3; row++) {
          const parentContainer = this._jsonPath + ':symBackgroundAnimReel' + reel;
          let backing = resourceManager.createObject(
            'movie',
            'mysteryBackingAnim_' + reel + '_' + row,
            parentContainer,
            {
              definition: 'mysteryBacking',
              x: this._anims[reel][row].anim.x,
              y: this._anims[reel][row].anim.y,
              anchor: 0.5,
              loop: true,
            }
          );
          backing.gotoAndStop(0);
          backing.visible = false;
          rowAnims.push(backing);
        }
        this._mysteryBackingAnims.push(rowAnims);
      }
    }

    playAnimsAtSameTime(data, callback = undefined) {
      data.forEach((symbolBg, index) => {
        const isFinal = index === data.length - 1;
        const finalAnimCallback = isFinal ? callback : undefined;

        if (finalAnimCallback) {
          this._currentCallback = finalAnimCallback;
        }

        const { reel, row } = symbolBg.cell;
        this.playAnim({ reel, row }, symbolBg.symbolId, 0, 1, finalAnimCallback);
      });
    }

    playAnims(data, lineDurations, callback = undefined) {
      const isRightToLeft = data.direction === -1;

      let symbolBgs = data.positions.sort((a, b) => a.reel - b.reel);
      if (isRightToLeft) {
        symbolBgs = symbolBgs.toReversed();
      }

      if (callback) {
        this._currentCallback = callback;
      }

      let delay = 0;
      for (let i = 0; i < gameData.numReels; i++) {
        const isFinal = i === gameData.numReels - 1;
        const finalAnimCallback = isFinal ? callback : undefined;
        this.playAnim(symbolBgs[i], data.symbol.value, delay, lineDurations[i], finalAnimCallback);
        delay += lineDurations[i];
      }
    }

    playAnim(positions, symId, delay, duration, callback) {
      const animFadeInDuration = 0.1;
      const animFadeOutDuration = 0.1;

      this._currentCallback = callback;

      if (positions == null) {
        if (callback) {
          const animFinishTime = delay + animFadeInDuration + duration + animFadeOutDuration;
          timerManager.addTimeout(animFinishTime * 1000, callback);
        }
        return;
      }

      const { reel, row } = positions;

      const anim = this._anims[reel][row];
      anim.anim.alpha = 0;
      anim.anim.visible = true;
      anim.anim.gotoAndPlay(0);

      this.setColour(anim.anim, symId);

      if (anim.task !== undefined) {
        anim.task.kill();
        anim.task = undefined;
      }

      anim.task = gsap.timeline();
      anim.task
        .to(anim.anim, {
          alpha: 1,
          duration: animFadeInDuration,
          delay,
        })
        .to(anim.anim, {
          duration,
        })
        .to(anim.anim, {
          alpha: 0,
          duration: animFadeOutDuration,
          onComplete: () => {
            if (callback) callback();
          },
        });
    }

    stopAnims() {
      for (let reel = 0; reel < 5; reel++) {
        for (let row = 0; row < 3; row++) {
          this._anims[reel][row].anim.gotoAndStop(0);
          this._anims[reel][row].anim.visible = false;

          if (this._anims[reel][row].task !== undefined) {
            this._anims[reel][row].task.kill();
            this._anims[reel][row].task = undefined;
          }

          this._mysteryBackingAnims[reel][row].gotoAndStop(0);
          this._mysteryBackingAnims[reel][row].visible = false;
        }
      }

      if (this._currentCallback) {
        this._currentCallback();
        this._currentCallback = undefined;
      }
    }

    showMysteryBacking(positions) {
      for (let i = 0; i < positions.length; i++) {
        const { reel, row } = positions[i];
        const backing = this._mysteryBackingAnims[reel][row];
        backing.visible = true;
        backing.gotoAndPlay(0);
      }
    }

    hideMysteryBacking() {
      for (let reel = 0; reel < 5; reel++) {
        for (let row = 0; row < 3; row++) {
          const backing = this._mysteryBackingAnims[reel][row];
          backing.visible = false;
          backing.gotoAndStop(0);
        }
      }
    }

    setColour(anim, symbol) {
      if (symbol === 0) {
        anim.tint = 0xff0000;
      } else if (symbol === 1) {
        anim.tint = 0xff7700;
      } else if (symbol === 2) {
        anim.tint = 0x0077ff;
      } else if (symbol === 3) {
        anim.tint = 0x7700ff;
      } else if (symbol === 4) {
        anim.tint = 0x77ff33;
      } else if (symbol === 5) {
        anim.tint = 0xff0000;
      } else if (symbol === 6) {
        anim.tint = 0xffaa33;
      } else {
        anim.tint = 0xffffff;
      }
    }

    onLayoutChange() {}
  }

  let creator = function (json) {
    return new SymBackgroundAnimDisplay();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('symBackgroundAnimDisplay', creator, initialise, filesRequired);
})();
